import { Howl } from 'howler';
import { ReportingTicket } from '../../api/reporting';

export enum LoopStatus {
  OFF,
  REPEAT_ALL,
  REPEAT_ONE,
}

type Playlist = {
  list: [];
  autoPlay: boolean;
  id: number;
  startFrom?: number;
  shuffle?: boolean;
  element: EventTarget | null;
};

export interface Music {
  // Properties
  isPlaying: boolean;
  playlist: unknown[];
  currentTrack: null | Howl;
  isPreview: boolean;
  currentIndex: number;
  timer: number;
  currentPlaylistId: string | number;
  currentTrackId: number;
  basePlaylist: unknown[];
  shuffled: boolean;
  loopStatus: LoopStatus;
  durationSeconds: number;
  volume: number;
  muted: boolean;
  controller: AbortController | null;
  seeked: boolean;
  requestedSeek: number;
  lastTracked: number;
  nextCheck: number;
  isEnded: boolean;
  reporting: ReportingTicket | null;
  position: ComputedRef<string>;
  duration: ComputedRef<string>;
  positionSeconds: ComputedRef<number>;
  hasNext: ComputedRef<boolean>;
  hasPrev: ComputedRef<boolean>;
  track: unknown;
  lastElementToFocus: EventTarget | null;
  // Methods
  setPlaylist({}: Playlist): Promise<unknown>;
  play(): Promise<boolean>;
  toggleMute(): Promise<void>;
  toggle(): Promise<boolean>;
  pause(): void;
  stop(): Promise<boolean>;
  next(): Promise<void>;
  setVolume(volume: number): void;
  prev(): Promise<void>;
  setTrack(): Promise<boolean>;
  selectTrack(index: string | number): Promise<void>;
  shuffle(): void;
  seek(seconds: number): void;
  toggleLoop(): void;
  sortItem(oldIndex: number, newIndex: number): void;
  removeTrack(index: number): Promise<void>;
  loadMoreCollectionTracks(): Promise<void>;
  addToQueue(track: { id: number }): void;
  playSingleTrack(track: { id: number }, element: EventTarget): void;
  musicCTAText(article: {}, type?: string): string;
}

declare module 'vue/types/vue' {
  interface Vue {
    $music: Music;
  }
}

declare module '@nuxt/types' {
  // Declare app options
  interface NuxtAppOptions {
    $music: Music;
  }
}
